var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBlob)?_c('text',{staticClass:"o-tachyon-particle"},[_vm._v(" "+_vm._s(_vm.blob)+" ")]):_c('circle',{staticClass:"o-tachyon-particle",attrs:{"r":"2"}})}
var staticRenderFns = []

export { render, staticRenderFns }